import { render, staticRenderFns } from "./amountList.vue?vue&type=template&id=f6752ee8&scoped=true&"
import script from "./amountList.vue?vue&type=script&lang=js&"
export * from "./amountList.vue?vue&type=script&lang=js&"
import style0 from "./amountList.vue?vue&type=style&index=0&id=f6752ee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6752ee8",
  null
  
)

export default component.exports